import config from 'react-global-configuration';
// eslint-disable-next-line no-unused-vars
import { ThunkAction } from 'redux-thunk';
import {
  VIEW_ACTION_APPEND,
  VIEW_ACTION_REPLACE,
  viewGetLoaded,
} from '@uncinc/react-drupal-core/dist/redux/actions/Entity/View';

import {
  referenceLoadingDone,
  referenceLoadingStart,
} from '../../UI/ReferenceLoading';

let qs = require('qs');

/**
 * Load data for a given view.
 *
 * @param {string} viewId - The view id
 * @param {string} displayId - The view display id.
 * @param {?number} [page] - The current page. Leave empty to let the pager decide.
 * @param {array} [args] - Contextual filter arguments
 * @param {Object} [filters] - Exposed filter arguments
 * @param {string} [action] - Action te perform after fetching view data
 * @param {boolean} [referenceLoading] - Use reference loading redux states.
 * @param {boolean} [loadAllPages] - Use reference loading redux states.
 *
 * @returns {ThunkAction} - Redux thunk
 */
export const viewGet = (viewId, displayId, page = null, args = [], filters = {}, action = VIEW_ACTION_REPLACE, referenceLoading = true, loadAllPages = false) => {
  return async (dispatch, getState) => {
    if (referenceLoading) {
      dispatch(referenceLoadingStart());
    }

    const API_URL = config.get('API_URL');
    const language = getState().getIn(['ui', 'language']);
    const MULTILINGUAL = config.get('MULTILINGUAL', true);
    const PATH = MULTILINGUAL ? `${API_URL}/${language}` : API_URL;
    let url = `${PATH}/entity/view/${viewId}/${displayId}/results?_format=json`;
    if (typeof page !== 'undefined' && page !== null) {
      url += `&page=${page}`;
    }

    if (Array.isArray(args) && args.length > 0) {
      const encodedArgs = args.map((item) => `args[]=${item}`).join('&');
      url = `${url}&${encodedArgs}`;
    }

    if (Object.keys(filters).length > 0) {
      const encodedArgs = qs.stringify({ filters: filters });
      url = `${url}&${encodedArgs}`;
    }

    try {
      const request = await fetch(url, { credentials: 'include' });
      const response = await request.json();
      dispatch(viewGetLoaded(viewId, displayId, response, action));

      if (loadAllPages && response.pager) {
        const next = 1 + (response.pager.current_page || 0);
        const total = response.pager.total_pages || 1;

        if (next < total) {
          await dispatch(viewGet(viewId, displayId, next, args, filters, VIEW_ACTION_APPEND, referenceLoading, loadAllPages));
        }
        else if (referenceLoading) {
          dispatch(referenceLoadingDone());
        }
      }
      else if (referenceLoading) {
        dispatch(referenceLoadingDone());
      }
    }
    catch {
      if (referenceLoading) {
        dispatch(referenceLoadingDone());
      }

      return Promise.reject();
    }

    return Promise.resolve();
  };
};

export const VIEW_RESET = 'VIEW_RESET';
export function viewReset(viewId) {
  return {
    type: VIEW_RESET,
    viewId,
  };
}
